import { type Writable, writable } from 'svelte/store'
import { decodeJwt, type JWTPayload } from 'jose'
import { userIsLoggedIn } from '../stores'

/** Decoded JWT payload — jose's standard registered claims plus arbitrary custom claims from the backend. */
export interface JwtPayload extends JWTPayload {
	// oxlint-disable-next-line typescript-eslint/no-explicit-any -- untrusted external payload with arbitrary custom claims, narrower than jose's `unknown` would break existing consumers
	[key: string]: any
}

export const jwt: Writable<JwtPayload> = writable({})

const url: string = '/api/jwt'

export async function getJwt(): Promise<boolean> {
	const response = await fetch(url)
	const json = await response.json()
	if (json.success) {
		const data = decodeJwt<JwtPayload>(json.token)
		jwt.set(data)
		userIsLoggedIn.set(true)
		return true
	} else {
		userIsLoggedIn.set(false)
		return false
	}
}

/**
 * HINT: don't touch unless you know what you are doing
 *
 * getJwT() returns a Promise
 * we need it to run before anything else
 * howver, forking Safari doesn't support it yet (maybe EoY 2026, it's in Interop 2026)
 * hence, we can't top-level await it
 * so we use a dirty, non-blocking IIFE whcih can cause other unexpected troubles
 *
 * to live is to suffer
 */

;(async () => {
	await getJwt().catch((error) => {
		console.error(error)
	})
})().catch((error) => {
	console.error(error)
})
